
import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';

const Rpt_FinalStock = () => {

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const [RoomType, setRoomType] = useState([]);
    const [Room, setRoom] = useState([]);
    const [deptdata, setdeptdata] = useState([]);

    const [data, setData] = useState([]);

    const today = new Date();

    const [FebData, setFebData] = useState([]);
    const [WData, setWData] = useState([]);

    const [frmdata, setfrmdata] = useState({
        fromdate: today.toISOString().split('T')[0],
        todate: today.toISOString().split('T')[0],
        deptcode: 0,
        status: 1
    });

    const [totalSums, setTotalSums] = useState({});

    const [itemdetail, setitemdetail] = useState({
        Washername: "",
        Washercode: 0,
        fabname: "",
        fabcode: 0
    });

    const {
        fabcode,
        fabname,
        Washercode,
        Washername
    } = itemdetail;

    const {
        fromdate,
        todate,
        status,
        deptcode
    } = frmdata;

    const tableRef = useRef(null);

    // =========================================================
    // SEARCH
    // =========================================================

    const [lotSearch, setLotSearch] = useState('');
    const [styleSearch, setStyleSearch] = useState('');
    const [sizeSearch, setSizeSearch] = useState('');

    // =========================================================
    // FABRICATOR CHANGE
    // =========================================================

    const onChangevalueFab = (fabcode, fabname) => {
        setitemdetail({
            ...itemdetail,
            fabcode: fabcode,
            fabname: fabname
        });
    };

    // =========================================================
    // WASHER CHANGE
    // =========================================================

    const onChangevalueWasher = (Washercode, Washername) => {
        setitemdetail({
            ...itemdetail,
            Washercode: Washercode,
            Washername: Washername
        });
    };

    // =========================================================
    // FILTER CHANGE
    // =========================================================

    const onChangevalue = (e) => {
        const {
            name,
            value
        } = e.target;

        const sanitizedValue = value.replace(
            /['"!`@#$%^&*+{}|;:,.<>?=]/g,
            ''
        );

        setfrmdata({
            ...frmdata,
            [name]: sanitizedValue
        });
    };

    // =========================================================
    // LOAD DATA
    // ORIGINAL LOGIC PRESERVED
    // =========================================================

    const loaddata = async () => {

        try {

            const billResponse = await axios.get(
                `${hostlink}/PurchaseMasFINALStock/${usershopid}`
            );

            const billData = billResponse.data;

            const filteredData = billData.filter(res => {

                const totalQuantity =
                    Number(res.stkInfab) +
                    Number(res.inQty);

                if (status == 0) {

                    return true;

                } else if (status == 1) {

                    return totalQuantity !== 0;

                } else if (status == 2) {

                    return res.inQty < 0;

                }

                return false;
            });

            setData(filteredData);

            console.log("Filtered Data Found...");

        } catch (error) {

            console.log("Data Not Found...", error);

        }

    };

    // =========================================================
    // INITIAL LOAD
    // =========================================================

    useEffect(() => {

        loaddata();

    }, []);

    // =========================================================
    // LOCAL SEARCH
    // LOT NO + STYLE + SIZE
    // =========================================================

    const filteredData = useMemo(() => {

        const lot = lotSearch
            .trim()
            .toLowerCase();

        const style = styleSearch
            .trim()
            .toLowerCase();

        const size = sizeSearch
            .trim()
            .toLowerCase();

        return data.filter(res => {

            const lotNo = String(
                res?.purchaseMas?.billno || ''
            ).toLowerCase();

            const styleNo = String(
                res?.purchaseMas?.style || ''
            ).toLowerCase();

            const sizeNo = String(
                res?.purchaseMas?.size || ''
            ).toLowerCase();

            return (
                (!lot || lotNo.includes(lot)) &&
                (!style || styleNo.includes(style)) &&
                (!size || sizeNo.includes(size))
            );

        });

    }, [
        data,
        lotSearch,
        styleSearch,
        sizeSearch
    ]);

    // =========================================================
    // SUMMARY
    // =========================================================

    const totalStock = useMemo(() => {

        return filteredData.reduce(
            (total, res) =>
                total +
                Number(res?.stkqty || 0),
            0
        );

    }, [filteredData]);

    const uniqueLots = useMemo(() => {

        return new Set(
            filteredData
                .map(
                    res =>
                        res?.purchaseMas?.billno
                )
                .filter(Boolean)
        ).size;

    }, [filteredData]);

    const uniqueStyles = useMemo(() => {

        return new Set(
            filteredData
                .map(
                    res =>
                        res?.purchaseMas?.style
                )
                .filter(Boolean)
        ).size;

    }, [filteredData]);

    const uniqueSizes = useMemo(() => {

        return new Set(
            filteredData
                .map(
                    res =>
                        res?.purchaseMas?.size
                )
                .filter(Boolean)
        ).size;

    }, [filteredData]);

    // =========================================================
    // FORMAT NUMBER
    // =========================================================

    const formatNumber = (value) => {

        return Number(value || 0).toLocaleString(
            'en-IN',
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        );

    };

    // =========================================================
    // CLEAR SEARCH
    // =========================================================

    const clearSearch = () => {

        setLotSearch('');
        setStyleSearch('');
        setSizeSearch('');

    };

    // =========================================================
    // EXCEL EXPORT
    // EXPORT FILTERED TABLE
    // =========================================================

    const exportToExcel = () => {

        if (
            !tableRef.current ||
            filteredData.length === 0
        ) {
            return;
        }

        const ws =
            XLSX.utils.table_to_sheet(
                tableRef.current
            );

        const wb =
            XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Final Stock'
        );

        XLSX.writeFile(
            wb,
            'Final Stock Report.xlsx'
        );

    };

    return (

        <div
            className="container-fluid py-3"
            style={{
                background: '#f6f8fb',
                minHeight: '100vh'
            }}
        >

            {/* =====================================================
                HEADER
            ====================================================== */}

            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow:
                        '0 6px 24px rgba(15,23,42,0.07)'
                }}
            >

                <div
                    style={{
                        background:
                            'linear-gradient(135deg,#0d6efd,#315efb)',
                        padding: '18px 20px',
                        color: '#fff'
                    }}
                >

                    <div
                        className="d-flex justify-content-between align-items-center flex-wrap gap-2"
                    >

                        <div
                            className="d-flex align-items-center"
                        >

                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '14px',
                                    background:
                                        'rgba(255,255,255,0.18)'
                                }}
                            >

                                <i
                                    className="fa-solid fa-layer-group"
                                    style={{
                                        fontSize: '21px'
                                    }}
                                ></i>

                            </div>

                            <div>

                                <div
                                    style={{
                                        fontSize: '20px',
                                        fontWeight: '700'
                                    }}
                                >
                                    Final Stock Report
                                </div>

                                <div
                                    style={{
                                        fontSize: '12px',
                                        opacity: 0.88
                                    }}
                                >
                                    Lot, Style & Size wise stock
                                </div>

                            </div>

                        </div>

                        <div
                            className="badge rounded-pill"
                            style={{
                                background:
                                    'rgba(255,255,255,0.16)',
                                padding: '9px 13px',
                                fontSize: '11px'
                            }}
                        >
                            {filteredData.length} Records
                        </div>

                    </div>

                </div>


                {/* =================================================
                    SEARCH / FILTER AREA
                ================================================== */}

                <div className="card-body p-3">

                    <div className="row g-2 align-items-end">

                        {/* LOT NO */}

                        <div className="col-12 col-md-4">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Lot No
                            </label>

                            <div className="input-group input-group-sm">

                                <span
                                    className="input-group-text bg-white"
                                    style={{
                                        borderRadius:
                                            '10px 0 0 10px'
                                    }}
                                >
                                    <i className="fa-solid fa-box text-primary"></i>
                                </span>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={lotSearch}
                                    onChange={(e) =>
                                        setLotSearch(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Search Lot No..."
                                    style={{
                                        borderRadius:
                                            '0 10px 10px 0'
                                    }}
                                />

                            </div>

                        </div>


                        {/* STYLE */}

                        <div className="col-12 col-md-4">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Style
                            </label>

                            <div className="input-group input-group-sm">

                                <span
                                    className="input-group-text bg-white"
                                    style={{
                                        borderRadius:
                                            '10px 0 0 10px'
                                    }}
                                >
                                    <i className="fa-solid fa-shirt text-primary"></i>
                                </span>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={styleSearch}
                                    onChange={(e) =>
                                        setStyleSearch(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Search Style..."
                                    style={{
                                        borderRadius:
                                            '0 10px 10px 0'
                                    }}
                                />

                            </div>

                        </div>


                        {/* SIZE */}

                        <div className="col-12 col-md-4">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Size
                            </label>

                            <div className="input-group input-group-sm">

                                <span
                                    className="input-group-text bg-white"
                                    style={{
                                        borderRadius:
                                            '10px 0 0 10px'
                                    }}
                                >
                                    <i className="fa-solid fa-ruler-combined text-primary"></i>
                                </span>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={sizeSearch}
                                    onChange={(e) =>
                                        setSizeSearch(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Search Size..."
                                    style={{
                                        borderRadius:
                                            '0 10px 10px 0'
                                    }}
                                />

                            </div>

                        </div>


                        {/* STATUS */}

                        <div className="col-12 col-md-4">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Status
                            </label>

                            <select
                                name="status"
                                value={status}
                                onChange={onChangevalue}
                                className="form-select form-select-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            >

                                <option value={0}>
                                    All
                                </option>

                                <option value={1}>
                                    Pending
                                </option>

                                <option value={2}>
                                    Received
                                </option>

                            </select>

                        </div>


                        {/* FROM DATE */}

                        <div className="col-6 col-md-3">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                From Date
                            </label>

                            <input
                                type="date"
                                name="fromdate"
                                value={fromdate}
                                onChange={onChangevalue}
                                className="form-control form-control-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            />

                        </div>


                        {/* TO DATE */}

                        <div className="col-6 col-md-3">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                To Date
                            </label>

                            <input
                                type="date"
                                name="todate"
                                value={todate}
                                onChange={onChangevalue}
                                className="form-control form-control-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            />

                        </div>


                        {/* ACTIONS */}

                        <div className="col-12 col-md-5">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Actions
                            </label>

                            <div
                                className="d-flex gap-2 flex-wrap"
                            >

                                <button
                                    type="button"
                                    onClick={loaddata}
                                    className="btn btn-primary btn-sm px-3"
                                    style={{
                                        borderRadius: '10px',
                                        fontWeight: '600'
                                    }}
                                >

                                    <i className="fa-solid fa-magnifying-glass-chart me-1"></i>

                                    Show

                                </button>


                                <button
                                    type="button"
                                    onClick={clearSearch}
                                    className="btn btn-outline-secondary btn-sm px-3"
                                    style={{
                                        borderRadius: '10px',
                                        fontWeight: '600'
                                    }}
                                >

                                    <i className="fa-solid fa-filter-circle-xmark me-1"></i>

                                    Clear

                                </button>


                                <button
                                    type="button"
                                    onClick={exportToExcel}
                                    className="btn btn-outline-success btn-sm px-3"
                                    disabled={
                                        filteredData.length === 0
                                    }
                                    style={{
                                        borderRadius: '10px',
                                        fontWeight: '600'
                                    }}
                                >

                                    <i className="fa-solid fa-file-excel me-1"></i>

                                    Excel

                                </button>


                                <PDFDownloadLink
                                    document={
                                        <PDFDocument
                                            data={filteredData}
                                            fromdate={fromdate}
                                            todate={todate}
                                        />
                                    }
                                    fileName="Final Stock Report.pdf"
                                    style={{
                                        textDecoration:
                                            'none'
                                    }}
                                >

                                    {({
                                        loading
                                    }) => (

                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm px-3"
                                            disabled={
                                                loading ||
                                                filteredData.length ===
                                                    0
                                            }
                                            style={{
                                                borderRadius:
                                                    '10px',
                                                fontWeight:
                                                    '600'
                                            }}
                                        >

                                            <i className="fa-regular fa-file-pdf me-1"></i>

                                            {loading
                                                ? 'Loading'
                                                : 'PDF'}

                                        </button>

                                    )}

                                </PDFDownloadLink>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                KPI CARDS
            ====================================================== */}

            <div className="row g-2 mb-3">

                <div className="col-6 col-md-3">

                    <SummaryCard
                        title="Records"
                        value={filteredData.length}
                        icon="fa-list"
                        subtitle="Visible records"
                    />

                </div>


                <div className="col-6 col-md-3">

                    <SummaryCard
                        title="Lots"
                        value={uniqueLots}
                        icon="fa-boxes-stacked"
                        subtitle="Unique lots"
                    />

                </div>


                <div className="col-6 col-md-3">

                    <SummaryCard
                        title="Styles"
                        value={uniqueStyles}
                        icon="fa-shirt"
                        subtitle="Unique styles"
                    />

                </div>


                <div className="col-6 col-md-3">

                    <SummaryCard
                        title="Total Stock"
                        value={formatNumber(
                            totalStock
                        )}
                        icon="fa-cubes"
                        subtitle="Final stock"
                    />

                </div>

            </div>


            {/* =====================================================
                ACTIVE SEARCH
            ====================================================== */}

            {(lotSearch ||
                styleSearch ||
                sizeSearch) && (

                <div
                    className="bg-white mb-3 px-3 py-2"
                    style={{
                        borderRadius: '12px',
                        border:
                            '1px solid #e9edf3',
                        boxShadow:
                            '0 3px 12px rgba(0,0,0,0.04)'
                    }}
                >

                    <div
                        className="d-flex align-items-center flex-wrap gap-2"
                    >

                        <span
                            className="text-muted"
                            style={{
                                fontSize: '11px',
                                fontWeight: '600'
                            }}
                        >
                            Active Filters:
                        </span>


                        {lotSearch && (

                            <span className="badge bg-primary rounded-pill">
                                Lot: {lotSearch}
                            </span>

                        )}


                        {styleSearch && (

                            <span className="badge bg-info rounded-pill">
                                Style: {styleSearch}
                            </span>

                        )}


                        {sizeSearch && (

                            <span className="badge bg-secondary rounded-pill">
                                Size: {sizeSearch}
                            </span>

                        )}


                        <span
                            className="text-muted"
                            style={{
                                fontSize: '11px'
                            }}
                        >
                            {filteredData.length} result(s)
                        </span>

                    </div>

                </div>

            )}


            {/* =====================================================
                TABLE
            ====================================================== */}

            <div
                className="card border-0"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow:
                        '0 6px 24px rgba(15,23,42,0.07)'
                }}
            >

                <div
                    className="card-header bg-white border-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
                    style={{
                        padding: '15px 18px'
                    }}
                >

                    <div>

                        <div
                            className="fw-bold"
                            style={{
                                color:
                                    '#1f2937'
                            }}
                        >
                            Final Stock Details
                        </div>

                        <small className="text-muted">
                            Lot No • Style • Size • Stock
                        </small>

                    </div>


                    <div
                        className="badge rounded-pill"
                        style={{
                            background:
                                '#eef4ff',
                            color:
                                '#2563eb',
                            padding:
                                '8px 12px'
                        }}
                    >
                        {filteredData.length} rows
                    </div>

                </div>


                <div
                    style={{
                        overflowX: 'auto',
                        maxHeight: '65vh'
                    }}
                >

                    <table
                        ref={tableRef}
                        className="table table-hover align-middle mb-0"
                        style={{
                            minWidth: '750px',
                            fontSize: '13px'
                        }}
                    >

                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                background:
                                    '#f1f5f9'
                            }}
                        >

                            <tr>

                                <th
                                    className="text-start"
                                    style={{
                                        padding:
                                            '12px 14px'
                                    }}
                                >
                                    Lot No
                                </th>

                                <th
                                    className="text-start"
                                    style={{
                                        padding:
                                            '12px 14px'
                                    }}
                                >
                                    Style
                                </th>

                                <th
                                    className="text-start"
                                    style={{
                                        padding:
                                            '12px 14px'
                                    }}
                                >
                                    Size
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding:
                                            '12px 14px'
                                    }}
                                >
                                    Stock
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {filteredData.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="4"
                                        className="text-center"
                                        style={{
                                            padding:
                                                '60px 20px'
                                        }}
                                    >

                                        <div
                                            className="d-flex align-items-center justify-content-center mx-auto mb-3"
                                            style={{
                                                width:
                                                    '58px',
                                                height:
                                                    '58px',
                                                borderRadius:
                                                    '18px',
                                                background:
                                                    '#f1f5f9',
                                                color:
                                                    '#94a3b8'
                                            }}
                                        >

                                            <i
                                                className="fa-solid fa-box-open"
                                                style={{
                                                    fontSize:
                                                        '24px'
                                                }}
                                            ></i>

                                        </div>


                                        <div className="fw-bold text-dark">
                                            No stock records found
                                        </div>


                                        <div
                                            className="text-muted mt-1"
                                            style={{
                                                fontSize:
                                                    '12px'
                                            }}
                                        >
                                            Try another Status, Lot No, Style or Size.
                                        </div>

                                    </td>

                                </tr>

                            ) : (

                                filteredData.map(
                                    (res, x) => {

                                        const lotNo =
                                            res?.purchaseMas?.billno ||
                                            '-';

                                        const style =
                                            res?.purchaseMas?.style ||
                                            '-';

                                        const size =
                                            res?.purchaseMas?.size ||
                                            '-';

                                        const stock =
                                            Number(
                                                res?.stkqty ||
                                                    0
                                            );

                                        return (

                                            <tr
                                                key={x}
                                            >

                                                <td
                                                    className="text-start fw-semibold"
                                                    style={{
                                                        padding:
                                                            '11px 14px',
                                                        color:
                                                            '#2563eb'
                                                    }}
                                                >
                                                    {lotNo}
                                                </td>


                                                <td
                                                    className="text-start"
                                                    style={{
                                                        padding:
                                                            '11px 14px'
                                                    }}
                                                >
                                                    {style}
                                                </td>


                                                <td
                                                    className="text-start"
                                                    style={{
                                                        padding:
                                                            '11px 14px'
                                                    }}
                                                >
                                                    {size}
                                                </td>


                                                <td
                                                    className="text-end fw-semibold"
                                                    style={{
                                                        padding:
                                                            '11px 14px',
                                                        color:
                                                            stock < 0
                                                                ? '#dc3545'
                                                                : '#198754'
                                                    }}
                                                >
                                                    {formatNumber(
                                                        stock
                                                    )}
                                                </td>

                                            </tr>

                                        );

                                    }
                                )

                            )}

                        </tbody>


                        {filteredData.length > 0 && (

                            <tfoot>

                                <tr
                                    style={{
                                        position:
                                            'sticky',
                                        bottom: 0,
                                        zIndex: 4,
                                        background:
                                            '#eaf2ff',
                                        borderTop:
                                            '2px solid #cbd5e1'
                                    }}
                                >

                                    <td></td>

                                    <td></td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding:
                                                '13px 14px'
                                        }}
                                    >
                                        Total :
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding:
                                                '13px 14px',
                                            color:
                                                '#2563eb'
                                        }}
                                    >
                                        {formatNumber(
                                            totalStock
                                        )}
                                    </td>

                                </tr>

                            </tfoot>

                        )}

                    </table>

                </div>

            </div>

        </div>
    );
};


// =============================================================
// SUMMARY CARD
// =============================================================

const SummaryCard = ({
    title,
    value,
    icon,
    subtitle
}) => {

    return (

        <div
            className="bg-white h-100"
            style={{
                borderRadius:
                    '16px',
                padding:
                    '16px',
                boxShadow:
                    '0 4px 18px rgba(0,0,0,0.06)',
                border:
                    '1px solid #edf0f5'
            }}
        >

            <div
                className="d-flex justify-content-between align-items-center"
            >

                <div>

                    <div
                        className="text-muted"
                        style={{
                            fontSize:
                                '11px',
                            fontWeight:
                                '600',
                            textTransform:
                                'uppercase',
                            letterSpacing:
                                '0.5px'
                        }}
                    >
                        {title}
                    </div>


                    <div
                        className="fw-bold mt-1"
                        style={{
                            fontSize:
                                '20px',
                            color:
                                '#1f2937'
                        }}
                    >
                        {value}
                    </div>


                    <div
                        className="text-muted mt-1"
                        style={{
                            fontSize:
                                '10px'
                        }}
                    >
                        {subtitle}
                    </div>

                </div>


                <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                        width:
                            '40px',
                        height:
                            '40px',
                        borderRadius:
                            '12px',
                        background:
                            '#eef4ff',
                        color:
                            '#2563eb'
                    }}
                >

                    <i
                        className={`fa-solid ${icon}`}
                    ></i>

                </div>

            </div>

        </div>

    );
};


// =============================================================
// PDF
// =============================================================

const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    const totalStock = data.reduce(
        (total, res) =>
            total +
            Number(res?.stkqty || 0),
        0
    );

    const formatNumber = (value) =>
        Number(value || 0).toFixed(2);

    return (

        <Document>

            <Page
                orientation="landscape"
                size="A4"
                style={pdfStyles.container}
            >

                <Text
                    style={pdfStyles.title}
                >
                    Final Stock Report
                </Text>

                <Text
                    style={pdfStyles.dateText}
                >
                    From : {fromdate} To : {todate}
                </Text>


                <View
                    style={pdfStyles.table}
                >

                    {/* HEADER */}

                    <View
                        style={pdfStyles.tableRow}
                        fixed
                    >

                        <Text
                            style={
                                pdfStyles.headerCell
                            }
                        >
                            Lot No
                        </Text>

                        <Text
                            style={
                                pdfStyles.headerCell
                            }
                        >
                            Style
                        </Text>

                        <Text
                            style={
                                pdfStyles.headerCell
                            }
                        >
                            Size
                        </Text>

                        <Text
                            style={
                                pdfStyles.headerCell
                            }
                        >
                            Stock
                        </Text>

                    </View>


                    {/* DATA */}

                    {data.map(
                        (res, x) => (

                            <View
                                key={x}
                                style={
                                    pdfStyles.tableRow
                                }
                            >

                                <Text
                                    style={
                                        pdfStyles.cell
                                    }
                                >
                                    {
                                        res?.purchaseMas
                                            ?.billno || ''
                                    }
                                </Text>

                                <Text
                                    style={
                                        pdfStyles.cell
                                    }
                                >
                                    {
                                        res?.purchaseMas
                                            ?.style || ''
                                    }
                                </Text>

                                <Text
                                    style={
                                        pdfStyles.cell
                                    }
                                >
                                    {
                                        res?.purchaseMas
                                            ?.size || ''
                                    }
                                </Text>

                                <Text
                                    style={
                                        pdfStyles.cell
                                    }
                                >
                                    {formatNumber(
                                        res?.stkqty
                                    )}
                                </Text>

                            </View>

                        )
                    )}


                    {/* TOTAL */}

                    <View
                        style={
                            pdfStyles.totalRow
                        }
                    >

                        <Text
                            style={
                                pdfStyles.totalCell
                            }
                        ></Text>

                        <Text
                            style={
                                pdfStyles.totalCell
                            }
                        ></Text>

                        <Text
                            style={
                                pdfStyles.totalCell
                            }
                        >
                            Total :
                        </Text>

                        <Text
                            style={
                                pdfStyles.totalCell
                            }
                        >
                            {formatNumber(
                                totalStock
                            )}
                        </Text>

                    </View>

                </View>

            </Page>

        </Document>
    );
};


// =============================================================
// PDF STYLES
// =============================================================

const pdfStyles = StyleSheet.create({

    container: {
        padding: 20
    },

    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 6,
        textAlign: 'center'
    },

    dateText: {
        fontSize: 9,
        marginBottom: 15,
        textAlign: 'center'
    },

    table: {
        display: 'table',
        width: '100%',
        borderWidth: 1,
        borderColor: '#444'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#999'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#999'
    },

    cell: {
        fontSize: 8,
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#ddd'
    },

    totalRow: {
        flexDirection: 'row',
        backgroundColor: '#eaf2ff',
        borderTopWidth: 1,
        borderColor: '#555'
    },

    totalCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#999'
    }

});

export default Rpt_FinalStock;

